<template>
  <div style="height: 100%">
    <Toast position="top-right" />
    <div id="tabs">
      <b-tabs content-class="mt-3">
        <b-tab title="Mensagens Customizadas" active>
          <div class="d-flex align-items-center mb-3">
            <h5 style="font-size: 0.95rem" class="mt-3">
              Ativar mensagens customizadas:
            </h5>
            <b-form-checkbox
              v-model="mensagemCustomizadaAtiva"
              name="check-button"
              class="custom-switch custom-switch-color pt-0 ml-2"
              switch
              size="lg"
            ></b-form-checkbox>
          </div>
          <div
            v-if="config && config.msg_customizado"
            class="row"
            style="height: 100%"
          >
            <div class="col-7">
              <div class="">
                <Accordion :activeIndex.sync="activeAba">
                  <AccordionTab
                    v-for="(g, key) in mensagensAgrupadas"
                    :key="key"
                    :header="key"
                  >
                    <ul class="list-group">
                      <li
                        class="faq-item-container"
                        :class="{ active: opcao.ativo }"
                        v-for="(opcao, index) in g"
                        :key="index"
                      >
                        <div class="flexer w-100">
                          <div>
                            <b-form-checkbox
                              v-model="opcao.ativo"
                              name="check-button"
                              class="custom-switch custom-switch-color pt-0"
                              switch
                              size="lg"
                            >
                            </b-form-checkbox>
                          </div>
                          <div class="w-100">
                            <p class="pergunta">{{ opcao._titulo }}</p>
                            <p class="resposta">{{ opcao.msg }}</p>
                          </div>
                          <div class="acoes-container">
                            <div
                              class="editar"
                              @click="abrirModalFormOpcao(opcao, index, index)"
                            >
                              <i class="fa-solid fa-pen" />
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </AccordionTab>
                </Accordion>
              </div>
            </div>
            <div class="col-5">
              <ChatPreviewWhatsapp :mensagens="mensagensChat" />
            </div>
          </div>
        </b-tab>
        <!--  -->
        <b-tab title="Limitações Customizadas">
          <div class="row" style="height: 100%">
            <div class="col-12">
              <div class="row">
                <div class="col-3">
                  <b-form-group label="Habilitar Limite Diário:" class="mr-3">
                    <b-form-checkbox
                      v-model="config.limitacoes_qtd_agenda.bool_limite_diario"
                      name="check-button"
                      class="custom-switch custom-switch-color pt-0 ml-2"
                      switch
                      size="lg"
                    ></b-form-checkbox>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    label="Limite Diário de Agendamentos:"
                    class="mr-3"
                  >
                    <b-form-input
                      type="number"
                      v-model="config.limitacoes_qtd_agenda.limite_diario"
                      min="0"
                      :disabled="
                        !config.limitacoes_qtd_agenda.bool_limite_diario
                      "
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <b-form-group label="Habilitar Limite Matutino:" class="mr-3">
                    <b-form-checkbox
                      v-model="
                        config.limitacoes_qtd_agenda.bool_limite_matutino
                      "
                      name="check-button"
                      class="custom-switch custom-switch-color pt-0 ml-2"
                      switch
                      size="lg"
                    ></b-form-checkbox>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    label="Limite Matutino de Agendamentos:"
                    class="mr-3"
                  >
                    <b-form-input
                      type="number"
                      v-model="config.limitacoes_qtd_agenda.limite_matutino"
                      min="0"
                      :disabled="
                        !config.limitacoes_qtd_agenda.bool_limite_matutino
                      "
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <b-form-group
                    label="Habilitar Limite Vespertino:"
                    class="mr-3"
                  >
                    <b-form-checkbox
                      v-model="
                        config.limitacoes_qtd_agenda.bool_limite_vespertino
                      "
                      name="check-button"
                      class="custom-switch custom-switch-color pt-0 ml-2"
                      switch
                      size="lg"
                    ></b-form-checkbox>
                  </b-form-group>
                </div>
                <div class="col-4">
                  <b-form-group
                    label="Limite Vespertino de Agendamentos:"
                    class="mr-3"
                  >
                    <b-form-input
                      type="number"
                      v-model="config.limitacoes_qtd_agenda.limite_vespertino"
                      min="0"
                      :disabled="
                        !config.limitacoes_qtd_agenda.bool_limite_vespertino
                      "
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <b-modal
      id="opcao-modal-center"
      centered
      no-close-button
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
    >
      <template #default="{ ok, cancel }">
        <div class="d-flex justify-content-between">
          <div>
            <h5 class="">Informe a mensagem</h5>
            <p class="" style="font-size: 0.85rem; color: #949494">
              Preencha com as mensagens que deseja que o chatbot responda
            </p>
          </div>
          <i
            style="cursor: pointer"
            @click="$bvModal.hide('opcao-modal-center')"
            class="fa-solid fa-xmark text-dark"
          ></i>
        </div>

        <div class="mt-3">
          <h6 style="font-size: 0.95rem">{{ opcaoModal.titulo }}</h6>
          <!-- <b-form-input id="input-1" v-model="opcaoModal.titulo"></b-form-input> -->
        </div>
        <div class="mt-3">
          <!-- <h6 style="font-size: 0.95rem">Resposta</h6> -->
          <b-form-textarea
            id="textarea"
            v-model="opcaoModal.msg"
            rows="8"
            no-resize
          ></b-form-textarea>
        </div>

        <div class="d-flex justify-content-between mt-4">
          <div class="d-flex align-items-center">
            <h6 style="font-size: 0.95rem" class="mt-3">Status da mensagem:</h6>
            <b-form-checkbox
              v-model="opcaoModal.ativo"
              name="check-button"
              class="custom-switch custom-switch-color pt-0 ml-2"
              switch
              size="lg"
            ></b-form-checkbox>
          </div>
          <div>
            <button
              class="mr-2 p-2"
              @click="cancel()"
              style="
                border: 1px solid #472282;
                border-radius: 5px;
                color: #472282;
                cursor: pointer;
              "
            >
              Cancelar
            </button>
            <button
              class="mr-2 p-2"
              style="
                border: 1px solid #472282;
                border-radius: 5px;
                background-color: #472282;
                color: white;
              "
              @click="handleOption"
            >
              Salvar
            </button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
// import ApiService from "@/core/services/api.service";
// import API_LINKS from "@/view/pages/painel/automacao/api.links";
import ChatPreviewWhatsapp from "./ChatPreviewWhatsapp.vue";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";

// Tooltip: () => import("@/view/pages/painel/dashboard/Tooltip.vue"),
// InputText: () => import("primevue/inputtext")

export default {
  name: "ConfiguracaoAgenda",
  components: {
    Toast: () => import("primevue/toast"),
    ChatPreviewWhatsapp,
    Accordion,
    AccordionTab
  },
  props: {
    config: {
      type: Object,
      default: () => null
    },
    modeloConfig: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      opcaoModal: {
        msg: "",
        ativo: true
      },
      faq_payload: {
        pergunta: "",
        resposta: "",
        ativa: true
      },
      activeAba: 0,
      activeAbaName: ""
    };
  },
  methods: {
    async handleOption() {
      const opcao = this.mensagensFormatada[this.opcaoModal.key];

      opcao.msg = this.opcaoModal.msg;
      opcao.ativo = this.opcaoModal.ativo;

      this.$bvModal.hide("opcao-modal-center");
    },
    async abrirModalFormOpcao(opcao) {
      if (!opcao) {
        return;
      }
      this.opcaoModal = {
        key: opcao._key,
        titulo: opcao._titulo,
        msg: opcao["msg"],
        ativo: opcao["ativo"]
      };
      this.$bvModal.show("opcao-modal-center");
    }
  },
  async mounted() {},
  computed: {
    mensagensChat() {
      // let valor = Object.values(this.config.msg_customizado)
      let valor = Object.values(this.mensagensAgrupadas)
        [this.activeAba]?.filter((m) => m.ativo)
        .flatMap((m) => {
          let text = m.msg;
          if (m._msgData) {
            text += m._msgData;
          }
          let msgsAnteriores = m._exemploRespostaAnteriores?.map((e) => {
            return { fromMe: true, text: e };
          });

          let msgPrincipal = {
            fromMe: false,
            text
          };

          let msgsSeguintes = m._exemploRespostaSeguinte?.map((e) => {
            return { fromMe: true, text: e };
          });

          const msgsTotal = [].concat(
            msgsAnteriores,
            msgPrincipal,
            msgsSeguintes
          );

          return msgsTotal;
        })
        .filter((m) => m);
      return valor;
    },
    mensagensAgrupadas() {
      if (!this.config) {
        return {};
      }
      const grouped = Object.values(this.mensagensFormatada).reduce(
        (acc, item) => {
          if (!acc[item._grupo]) {
            acc[item._grupo] = [];
          }
          acc[item._grupo].push(item);
          return acc;
        },
        {}
      );

      return grouped;
    },
    mensagensFormatada() {
      let m = {
        ...this.config?.msg_customizado,
        // ...this.config?.filtro_customizado,
        ...this.config?.msg_customizado?.filtros
      };
      delete m.filtros;
      Object.entries(m).forEach(([key, value]) => {
        value._key = key;
      });
      return m;
    },
    mensagemCustomizadaAtiva: {
      get() {
        // return !!this.config;
        return !!this.config && this.config.msg_customizado;
      },
      set(value) {
        if (value) {
          let v;
          if (this.config?.mar_customizacao) {
            v = Object.assign(
              {},
              this.modeloConfig,
              this.config.mar_customizacao
            );
          } else {
            v = Object.assign({}, this.modeloConfig);
          }
          this.$emit("update:config", v);
        } else {
          // this.$emit("update:config", null);
          this.config.msg_customizado = null;
          this.$emit("update:config", this.config);
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300&display=swap");

.p-togglebutton.p-button {
  background: #e4e6ef;
  border: 1px solid #ced4da;
  color: #495057 !important;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s;
  text-transform: uppercase;
}

.p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover {
  background: #f8f9fa;
  border: 1px solid #ced4da;
  color: #495057 !important;
}

.p-togglebutton.p-button.p-highlight {
  background: #e8f3d6;
  border-color: #e8f3d6;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s;
}

.faq-item-container {
  display: flex;
  height: 75px;
  background: #eeeeee;
  opacity: 0.5;
  border: 1px solid #adb5bd;
  &.active {
    background: white;
    border-color: #dcdfe3;
    opacity: 1;
  }
  border-radius: 4px !important;
  align-items: center;
  justify-content: space-betweens;
  width: 100%;
  padding: 1rem;
  margin-bottom: 1rem;
  p {
    margin: 0;
  }
  .flexer {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  .acoes-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    div {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .editar {
      border: 1px solid #dcdfe3;
      border-radius: 4px;
      i {
        font-size: 1rem;
        color: #404254 !important;
      }
    }
    .remover {
      border: 1px solid #dcdfe3;
      border-radius: 4px;
      i {
        font-size: 1rem;
        color: #404254 !important;
      }
    }
  }
  .faq-idx-container {
    font-size: 1.8rem;
    width: 30px;
    margin-right: 12px;
    .pergunta-numero {
      color: #472282;
      margin: 0;
    }
  }
  .pergunta {
    font-size: 1rem;
    font-weight: 600;
    color: #000;
    margin: 0;
  }
  .resposta {
    font-size: 0.9rem;
    width: 95%;
    color: #000;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: keep-all;
  }
}

.novo-menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px dashed #000;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
  height: 59px;
  &:hover {
    background: #eee;
    color: #000;
  }
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #472282;
  background-color: #472282;
}

.meu-alerta {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  text-align: left;
}

.meu-titulo {
  font-weight: 600;
  font-size: 1.25rem;
  color: #333;
}

.meu-texto {
  color: #6c757d;
  font-size: 0.95rem;
  margin-top: 0.5rem;
  padding: 0;
}

.btn-cancelar {
  background-color: #fff;
  border: 1px solid #6f42c1;
  color: #6f42c1;
  border-radius: 6px;
  padding: 0.5rem 1.25rem;
  font-weight: 500;
  margin-right: 0.5rem;
}

.btn-excluir {
  background-color: #6f42c1;
  border: 1px solid #6f42c1;
  color: white;
  border-radius: 6px;
  padding: 0.5rem 1.25rem;
  font-weight: 500;
}

.swal2-header {
  display: block;
  text-align: left !important;
}

.swal2-content {
  display: block;
  text-align: left !important;
}

.swal2-actions {
  display: flex;
  justify-content: flex-end;
  padding-right: 1rem;
}
</style>
